<template>
  <span v-if="!task.discarded">
    <i class="material-icons pointer ml-1" data-toggle="modal" :data-target="'#projectModal' + task.id">folder_special</i>
    <div class="modal fade" :id="'projectModal' + task.id">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t("projects.plural") }}</h5>
          </div>
          <div class="modal-body">
            <div class="input-group mb-3">
              <ProjectAreaSelector ref="project_area_selector" />
              <p>
                <input type="text" class="d-block form-control" v-model="name" v-on:keyup.enter="addProject" :placeholder="$t('projects.new')">
              </p>
              <div class="input-group">
                <button class="btn btn-primary" type="button" @click="addProject" style="height: 36px;">Add {{ $t("projects.singular") }} </button>
              </div>
            </div>

            <button type="button" class="btn btn-primary pull-right" data-dismiss="modal">Done</button>
    
            <span class="pointer h5" @click="toggleProject(null)">
              <span>
                <i v-if="projectAttached(null)" class="material-icons bottom-align text-success">folder_special</i>
                <i v-else class="material-icons bottom-align text-secondary">folder_open</i>
                <span >Inbox</span>
              </span>
            </span>
            
            <br>

            <span v-for="projectArea in allProjectAreas" :key="projectArea.id">
              <span class="h5">{{projectArea.name}}</span>
              <ul class="mt-2 list-group" @click.stop="">
                <li v-for="project in projectArea.projects" :key="project.id" class="list-group-item pointer">
                  <span>
                    <i v-if="projectAttached(project.id)" class="material-icons bottom-align text-danger" @click="removeFromProject()">folder_special</i>
                    <i v-else class="material-icons bottom-align text-secondary" @click="toggleProject(project.id)">folder_open</i>
                    <span class="text-muted">{{project.name}}</span>
                  </span>
                </li>          
              </ul>
            </span>
          </div>
        </div>
      </div>
    </div>
  </span>
</template>

<script>
// var firstBy = require('thenby');
import api from "api";
import ProjectAreaSelector from 'ProjectAreaSelector';

export default {
  data() {
    return {
      name: '',
      project_area_id: this.$store.state.project_areas[0].id, 
      allProjectAreas: this.$store.state.project_areas,
      project_area_name: ''
    };
  },
  components: {
    ProjectAreaSelector
  },
  props: {
    task: {
      type: Object
    }
  },
  methods: {
    projectAttached(projectId){
      if(projectId == this.task.project_id){
        return true;
      } else {
        return false;
      }
    },
    addProject(){
      if(this.name && (typeof this.project_area_id == 'number' || this.project_area_name != '')){
        api.createProject({ name: this.name, project_area_id: this.project_area_id, project_area_name: this.project_area_name }).then(response => {
          this.name = '';
          this.project_area_id = '';
          this.project_area_name = '';
          this.$refs.project_area_selector.resetData()
          this.toggleProject(response.data.id)
        });
      }

    },
    removeFromProject(){
      if(confirm('Are you sure you want to remove "' + this.task.title + '" from the Library?')){
        this.toggleProject(null, false)
      }
    },
    toggleProject(projectId, redirect = true){
      var router = this.$router
      var task = this.task
      var originalProjectId = task.project_id

      this.task.project_id = projectId;

      api.updateTask(this.task.id, { project_id: projectId }).then(response => {
        store.commit('removeFromSortedGroup', {
          taskId: task.id,
          groupName: 'projectId' + originalProjectId
        })

        store.commit('addToSortedGroup', {
          taskId: task.id,
          groupName: 'projectId' + projectId
        })

        $('#projectModal' + this.task.id).modal('hide');
        $('body').removeClass('modal-open');
        $(".modal-backdrop").hide();
        
        if(redirect){
          if(projectId){
            router.push({ name: 'project', params: { id: projectId } }) 
          } else {
            router.push({ name: 'todo', params: { task_id: task.id } })
          }
        } 
      });
    }
  }
}
</script>
